import { PatchNotePayload } from '../models/note';
import { noteSchema, patchNotePayloadSchema } from '../models/note.schema';

export const patch = (id: number, payload: PatchNotePayload) => {
  return {
    endpoint: `/notes/${id}`,
    method: 'PATCH',
    payload,
    responseSchema: noteSchema,
    payloadSchema: patchNotePayloadSchema,
  } as const;
};
